import type { PrivacyRegime, ViewState } from '@transcend-io/airgap.js-types';

// Matched case-insensitively; keep in sync with Snappea's privacy_choices.js.
export const US_PRIVACY_REGIMES: PrivacyRegime[] = [
  'cdpa',
  'cpa',
  'cpra',
  'nevada-sb220',
  'us-dnss',
  'united-states-hidden',
];

export const US_PRIVACY_CHOICES_VIEW_STATE: ViewState = 'DoNotSellExplainer';

export const FALLBACK_PRIVACY_CHOICES_VIEW_STATE: ViewState = 'QuickOptions';
